<!-- Footer of every page and of the profile picker: the legal pages (pages of the app at /privacy, /cookie, /copyright,
     in the UI language; opened in the same tab, Back returns; from the profile picker they replace it: src/features/legal.ts)
     and the version, which opens the release notes -->
<script setup lang="ts">
import { useI18n } from '../composables/useI18n'
import { APP_VERSION } from '../features/settings'
import { CONFIG } from '../config'
import { legalPath } from '../navigation'
import { useDialogsStore } from '../stores/dialogs'

const { t } = useI18n()
const dialogs = useDialogsStore()
const links = [['privacy', t('Privacy')], ['cookie', t('Cookie policy')], ['copyright', t('Copyright')]] as const
</script>

<template>
  <footer class="app-footer flex-shrink-0 mt-auto pt-3 pb-1 text-center text-[11px] text-gray-500">
    <nav class="flex flex-wrap justify-center gap-x-3 gap-y-1">
      <template v-for="([doc, label], i) in links" :key="doc">
        <span v-if="i" aria-hidden="true">·</span>
        <RouterLink :to="legalPath(doc)" class="hover:text-brand hover:underline">{{ label }}</RouterLink>
      </template>
    </nav>
    <p class="mt-1">© 2026 {{ CONFIG.author }} · <button type="button" :title="t('What\'s new and updates')" class="hover:text-brand hover:underline" @click="dialogs.show('changelog', {})">Hideo {{ APP_VERSION }}</button></p>
  </footer>
</template>
